import { GetCommonSettings } from '@themes/common/data';
// use english if development
const isDevelopment = process.env.NODE_ENV === 'development';
const LOCALE = isDevelopment ? 'en' : globalThis.Shopify.locale || 'en';
/**
 * Simple translation hook for the wall builder component
 * This can be extended later to integrate with a global translation system
 */
export function useTranslation(locale = LOCALE) {
    var _a, _b;
    const settings = GetCommonSettings();
    const wb = (((_a = settings === null || settings === void 0 ? void 0 : settings.translations) === null || _a === void 0 ? void 0 : _a.wall_builder) || ((_b = globalThis.translations) === null || _b === void 0 ? void 0 : _b.wall_builder));
    const t = (component, key) => {
        var _a;
        const value = (_a = wb === null || wb === void 0 ? void 0 : wb[component]) === null || _a === void 0 ? void 0 : _a[key];
        if (typeof value === 'string')
            return value;
        // Fallback: show key path when missing to ease debugging
        return `${String(component)}.${String(key)}`;
    };
    return { t };
}
